<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <h2 class="title">
        {{ header }}
      </h2>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <div
        class="pt-8"
        v-html="response"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'FAQSection',
  props: {
    header: {
      type: String,
      required: true
    },
    response: {
      type: String,
      required: true
    },
    index: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
h2.title {
  font-weight: bold;
  margin: 0;
}
</style>
